import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import $ from "jquery";

const Clients = ({ icon }) => {

    const [data, setData] = useState([]);
    const getData = async () => {
        const { data } = await axios.get('/client');
        setData(data);
    };

    useEffect(() => {
        getData();
        $('.nav-item').removeClass('active');
        $('.nav-item').each(function () {
            if ($(this).find('a').attr('href') === window.location.pathname) {
                $(this).addClass('active');
            }
        });
    }, []);


    useEffect(() => {
        if (data.length > 0) {
            if (!window.$.fn.dataTable.isDataTable('.dt-tbl')) {
                window.$('.dt-tbl').DataTable();
            }
        }
    }, [data]);

    const [selectedFile, setSelectedFile] = useState(null);
    const uploadChange = async (e) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        const { data } = await axios.post("/upload", formData);
        setSelectedFile(data);
    };

    return (
        <div className="page-content">
            <nav className="page-breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Main</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Brands</li>
                </ol>
            </nav>
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <h6 className="card-title">Client List</h6>
                                </div>
                                <div className="col-md-6 d-flex justify-content-end">
                                    <button className="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#new">
                                        <icon.Plus />
                                        <span className="ms-2">New Client</span>
                                    </button>
                                    <div className="modal fade" id="new" tabIndex={-1} aria-labelledby="new" aria-hidden="true">
                                        <div className="modal-dialog modal-md">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="newcategory">New Client</h5>
                                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                </div>
                                                <form onSubmit={(e) => {
                                                    e.preventDefault();
                                                    const formData = new FormData(e.target);
                                                    const data = Object.fromEntries(formData);
                                                    axios.post(`/client`, data).then(() => {
                                                        window.$(`#new`).modal('hide');
                                                        toast.success('Added Successfully');
                                                        getData();
                                                    })
                                                }} >
                                                    <div className="modal-body">
                                                        <div className="card-title">
                                                            <p className="alert alert-fill-light">English</p>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Client Name</label>
                                                            <input type="text" className="form-control" name="title_en" placeholder="Client Title" required />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Addreess</label>
                                                            <input type="text" className="form-control" name="address_en" placeholder="Client Address" required />
                                                        </div>


                                                        <div className="card-title">
                                                            <p className="alert alert-fill-light">Arabic</p>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Client Name</label>
                                                            <input type="text" className="form-control" name="title_ar" placeholder="Client Title" required />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Addreess</label>
                                                            <input type="text" className="form-control" name="address_ar" placeholder="Client Address" required />
                                                        </div>


                                                        <div className="card-title">
                                                            <p className="alert alert-fill-light">Kurdish</p>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Client Name</label>
                                                            <input type="text" className="form-control" name="title_krd" placeholder="Client Title" required />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Addreess</label>
                                                            <input type="text" className="form-control" name="address_krd" placeholder="Client Address" required />
                                                        </div>

                                                        <div className="mb-3">
                                                            <label className="form-label">Phone No.</label>
                                                            <input type="text" className="form-control" name="phone" placeholder="Client Phone" required />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label">Image</label>
                                                            <input type="file" className="form-control" onChange={uploadChange} accept="application/pdf, image/*" required />
                                                            <input type="hidden" name="logo" defaultValue={selectedFile} required />
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                        <button type="submit" className="btn btn-primary">Submit</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table className="table table-striped table-sm dt-tbl" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th></th>
                                        <th>Client</th>
                                        <th>option</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td><img src={`../../${item.logo}`} alt={item.title_en} className="img-fluid" style={{ width: "50px" }} /></td>
                                                <td>{item.title_en}</td>
                                                <td>
                                                    <span type="button" className="badge bg-warning text-dark  mx-1" data-bs-toggle="modal" data-bs-target={`#edit${item.id}`}>
                                                        <icon.Edit size="18" />
                                                    </span>
                                                    <span type="button" className="badge bg-danger mx-1"
                                                        onClick={() => {
                                                            Swal.fire({
                                                                title: 'Are you sure?',
                                                                text: "You won't be able to revert this!",
                                                                icon: 'warning',
                                                                showCancelButton: true,
                                                                confirmButtonColor: '#3085d6',
                                                                cancelButtonColor: '#d33',
                                                                confirmButtonText: "Yes, delete it!",
                                                            }).then((result) => {
                                                                if (result.isConfirmed) {
                                                                    axios.delete(`/client/${item.id}`).then(() => {
                                                                        getData();
                                                                    })
                                                                }
                                                            })
                                                        }}>
                                                        <icon.Trash size="18" />
                                                    </span>
                                                </td>
                                                <div className="modal fade" id={`edit${item.id}`} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                    <div className="modal-dialog modal-md">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="editcategory">Edit {item.title}</h5>
                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                            </div>
                                                            <form onSubmit={(e) => {
                                                                e.preventDefault();
                                                                const formData = new FormData(e.target);
                                                                const data = Object.fromEntries(formData);
                                                                axios.put(`/client/${item.id}`, data).then(() => {
                                                                    window.$(`#edit${item.id}`).modal('hide');
                                                                    toast.success('Updated Successfully');
                                                                    getData();
                                                                })
                                                            }} >
                                                                <div className="modal-body">
                                                                    <div className="card-title">
                                                                        <p className="alert alert-fill-light">English</p>
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="form-label">Client Name</label>
                                                                        <input type="text" className="form-control" name="title_en" placeholder="Client Title" defaultValue={item.title_en} required />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="form-label">Client Address</label>
                                                                        <input type="text" className="form-control" name="address_en" placeholder="Client Address" defaultValue={item.address_en} required />
                                                                    </div>

                                                                    <div className="card-title">
                                                                        <p className="alert alert-fill-light">Arabic</p>
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="form-label">Client Name</label>
                                                                        <input type="text" className="form-control" name="title_ar" placeholder="Client Title" defaultValue={item.title_ar} required />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="form-label">Client Address</label>
                                                                        <input type="text" className="form-control" name="address_ar" placeholder="Client Address" defaultValue={item.address_ar} required />
                                                                    </div>

                                                                    <div className="card-title">
                                                                        <p className="alert alert-fill-light">Kurdish</p>
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="form-label">Client Name</label>
                                                                        <input type="text" className="form-control" name="title_krd" placeholder="Client Title" defaultValue={item.title_krd} required />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="form-label">Client Address</label>
                                                                        <input type="text" className="form-control" name="address_krd" placeholder="Client Address" defaultValue={item.address_krd} required />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <label className="form-label">Phone No.</label>
                                                                        <input type="text" className="form-control" name="phone" placeholder="Client Phone" defaultValue={item.phone} required />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="form-label">Image</label>
                                                                        <input type="file" className="form-control" onChange={uploadChange} accept="application/pdf, image/*" />
                                                                        <input type="hidden" name="logo" defaultValue={selectedFile ? selectedFile : item.logo} required />
                                                                        <img className="img-fluid rounded mt-2" src={`../../${item.logo}`} alt={item.title} />
                                                                    </div>
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                                    <button type="submit" className="btn btn-primary">Update</button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Clients;